"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveFromCartEvent = void 0;
const abstract_sales_event_1 = require("./abstract-sales.event");
class RemoveFromCartEvent extends abstract_sales_event_1.AbstractSalesEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'remove_from_cart';
    }
    getData() {
        return {
            currency: this.config.currency,
            value: this.config.value,
            items: Array.isArray(this.config.items) ? this.config.items.map(item => (Object.assign({}, item))) : [],
        };
    }
}
exports.RemoveFromCartEvent = RemoveFromCartEvent;
//# sourceMappingURL=remove-from-cart.event.js.map